<template functional>
  <div
    :class="[
      $style.align,
      props.left && $style.left,
      props.right && $style.right,
      props.center && $style.center,
      props.spaceBetween && $style.spaceBetween,
      props.ignoreChildren && $style.ignoreChildren]"
  >
    <slot />
  </div>
</template>

<style lang="scss" module>

.align {
  &.left {
    text-align: left;
  }

  &.right {
    text-align: right;
  }

  &.center {
    text-align: center;
  }

  &.spaceBetween {
    display: flex;
    justify-content: space-between;
  }

  > * {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
  }

  &.ignoreChildren {
    > * {
      text-align: inherit;
    }
  }
}

</style>

<script>

export default {
  props: {
    left: {
      type: Boolean,
      required: false,
    },
    right: {
      type: Boolean,
      required: false,
    },
    center: {
      type: Boolean,
      required: false,
    },
    spaceBetween: {
      type: Boolean,
      required: false,
    },
    ignoreChildren: {
      type: Boolean,
      default: false,
    },
  },
};

</script>

